import type { Faq, FaqStatus } from '@/domain/faqs/entities/faq.entity'

export interface FaqDto {
  id?: string | number
  question?: string
  answer?: string
  status?: string
  isActive?: boolean
  createdAt?: string
  created_at?: string
}

function normalizeStatus(raw: unknown): FaqStatus {
  const s = String(raw ?? 'active').toLowerCase()
  return s === 'inactive' ? 'inactive' : 'active'
}

export function mapFaqDtoToEntity(dto: FaqDto): Faq {
  return {
    id: String(dto.id ?? ''),
    question: String(dto.question ?? ''),
    answer: String(dto.answer ?? ''),
    status:
      dto.isActive === false
        ? 'inactive'
        : normalizeStatus(dto.status),
    createdAt: String(dto.createdAt ?? dto.created_at ?? ''),
  }
}
